import React from 'react'
// ##
import BuyersTable from '../../modules/Buyer/components/BuyersTable'

export default function BuyersPage() {
  return <BuyersTable />
}
